import { render, staticRenderFns } from "./NewContactModal.vue?vue&type=template&id=09397c5e"
import script from "./NewContactModal.vue?vue&type=script&lang=js"
export * from "./NewContactModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports